(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3270],{

/***/ 67099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77058);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _src_components_atoms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52738);
/* harmony import */ var _src_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54176);
/* harmony import */ var _src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9465);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);










var Header = function Header(_ref) {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2;

  var setSideMenuShow = _ref.setSideMenuShow;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("header", true)),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "md:block hidden border-b ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("border-grayBackground")),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "wrapper mx-auto",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "flex flex-row py-2 items-center justify-between",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "flex flex-row items-center",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: "pr-[36px] relative group",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                prefetch: false,
                href: "/",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                  className: "text-sm text-white font-bold" // id={
                  //   process.env.NEXT_PUBLIC_APP_NAME != "PrefabWorld" &&
                  //   process.env.NEXT_PUBLIC_APP_NAME != "WorldCasino" &&
                  //   process.env.NEXT_PUBLIC_APP_NAME != "LuxResort Club" &&
                  //   process.env.NEXT_PUBLIC_APP_NAME != "AparthotelClub"
                  //     ? "sub-menu-prelaunch-header"
                  //     : ""
                  // }
                  ,
                  children: "SpaClub"
                })
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "flex flex-row items-center",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("btn-border"), " rounded-full px-3 pb-1 mr-0 h-[30px] flex justify-center items-center w-104px text-center"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                prefetch: false,
                href: "/".concat((_process$env$NEXT_PUB = "SpaClub") === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.replace(" ", "")) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : _process$env$NEXT_PUB2.toLowerCase(), "-pro/"),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                  className: "text-sm h-[16px] font-semibold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("text-white", true)),
                  children: t("key_web_apply")
                })
              })
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "wrapper-no-padding mx-auto ".concat( false ? 0 :  false ? 0 : "py-4", " sm:px-9 px-4"),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: "flex flex-row items-center justify-between",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "sm:block hidden cursor-pointer w-[150px]",
          onClick: function onClick() {
            return setSideMenuShow(true);
          },
          style: {
            height: 20
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_src_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
            source: "/icons/ic_menu.svg",
            width: 29,
            height: 20,
            layout: "fixed",
            alt: "menu"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "sm:hidden block cursor-pointer w-[30px]",
          onClick: function onClick() {
            return setSideMenuShow(true);
          },
          style: {
            height: 22
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_src_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
            source: "/icons/ic_menu_mobile.svg",
            width: 30,
            height: 22,
            layout: "fixed",
            alt: "menu"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            className: "sm:block hidden",
            style: {
              height:  false ? 0 :  false ? 0 : 52.8
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_src_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              source: "/images/logo_spaclub.png",
              width:  false ? 0 :  false ? 0 : 182,
              height:  false ? 0 :  false ? 0 : 52.8,
              layout: "fixed",
              alt: "".concat("SpaClub", " logo")
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            className: "sm:hidden block",
            style: {
              height:  false ? 0 :  false ? 0 : 34
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_src_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
              source: "/images/logo_spaclub.png",
              width:  false ? 0 :  false ? 0 : 120,
              height:  false ? 0 :  false ? 0 : 34,
              layout: "fixed",
              alt: "".concat("SpaClub", " logo")
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "sm:hidden block w-[30px]",
          children: "\xA0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "sm:block hidden w-[150px]",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: "/guides",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
              className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("btn-gradient"), " flex justify-center items-center w-150px h-40px rounded-full uppercase cursor-pointer"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "text-white text-base font-bold",
                children: "Guides"
              })
            })
          })
        })]
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Header);

/***/ }),

/***/ 92063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _src_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54176);
/* harmony import */ var _src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9465);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28908);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);









var SideMenu = function SideMenu(_ref) {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2;

  var sideMenuShow = _ref.sideMenuShow,
      setSideMenuShow = _ref.setSideMenuShow,
      sideMenuHeaderShow = _ref.sideMenuHeaderShow,
      setSideMenuHeaderShow = _ref.setSideMenuHeaderShow;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: "fixed top-0 left-0 ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("bg-black7", true), " h-screen overflow-y-auto w-305px ").concat(sideMenuShow ? "translate-x-0 opacity-100" : "-translate-x-full opacity-0", " transition-all duration-300 h-full z-[999]"),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "pt-10 pl-8",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: "cursor-pointer inline-block",
          onClick: function onClick() {
            return setSideMenuShow(false);
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("svg", {
            width: "17",
            height: "17",
            viewBox: "0 0 17 17",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M0.646446 1.35355C0.451185 1.15829 0.451185 0.841709 0.646446 0.646447C0.841709 0.451184 1.15829 0.451184 1.35355 0.646447L8.5 7.79289L15.6464 0.646447C15.8417 0.451184 16.1583 0.451184 16.3536 0.646447C16.5488 0.841709 16.5488 1.15829 16.3536 1.35355L9.20711 8.5L16.3536 15.6464C16.5488 15.8417 16.5488 16.1583 16.3536 16.3536C16.1583 16.5488 15.8417 16.5488 15.6464 16.3536L8.5 9.20711L1.35355 16.3536C1.15829 16.5488 0.841709 16.5488 0.646447 16.3536C0.451185 16.1583 0.451185 15.8417 0.646447 15.6464L7.79289 8.5L0.646446 1.35355Z",
              fill: (0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("svg-white")
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        // id={
        //   process.env.NEXT_PUBLIC_APP_NAME != "PrefabWorld" &&
        //   process.env.NEXT_PUBLIC_APP_NAME != "WorldCasino" &&
        //   process.env.NEXT_PUBLIC_APP_NAME != "LuxResort Club" &&
        //   process.env.NEXT_PUBLIC_APP_NAME != "AparthotelClub"
        //     ? "sub-menu-prelaunch"
        //     : ""
        // }
        className: "border-b ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("border-white2"), " pt-7 pb-4 pl-8"),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: "text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-bold cursor-pointer") // onClick={() => setSideMenuHeaderShow(!sideMenuHeaderShow)}
          ,
          children: "SpaClub"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: "pl-8 pt-1 py-3 border-b ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("border-white2")),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-regular uppercase py-3"),
            children: "Home"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/guides",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-regular uppercase py-3"),
            children: "Guides"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/".concat((_process$env$NEXT_PUB = "SpaClub") === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.replace(" ", "")) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : _process$env$NEXT_PUB2.toLowerCase(), "-pro/"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-regular uppercase py-3"),
            children: "Apply"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/about",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-regular uppercase py-3"),
            children: "About"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/contact",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " font-regular uppercase py-3"),
            children: "Contact"
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: "pl-8 pt-1 py-3",
        children: [ false && /*#__PURE__*/0, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
          href: "/cookie-policy",
          className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-gray2-dark", true), " font-regular py-3"),
          children: "Cookies"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/legal",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-gray2-dark", true), " font-regular py-3"),
            children: "Legal"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          prefetch: false,
          href: "/sitemap.xml",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
            className: "block text-base ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-gray2-dark", true), " font-regular py-3"),
            children: "Sitemap"
          })
        })]
      })]
    }), sideMenuShow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6___default()), {
      style: {
        backgroundColor: "rgba(89, 89, 89, 0.45)",
        width: "100%",
        height: "100%",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 500
      },
      onPress: function onPress() {
        return setSideMenuShow(false);
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SideMenu);

/***/ }),

/***/ 1868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77058);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var _components_web_Header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67099);
/* harmony import */ var _components_web_Footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52460);
/* harmony import */ var _components_web_SideMenu__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92063);
/* harmony import */ var _src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9465);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);












var Legal = function Legal() {
  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      sideMenuShow = _useState[0],
      setSideMenuShow = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      sideMenuHeaderShow = _useState2[0],
      setSideMenuHeaderShow = _useState2[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
      title: "Legal - ".concat("SpaClub"),
      canonical: "https://".concat("www.spaclub.co", "/legal"),
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: "https://".concat("www.spaclub.co", "/legal"),
        title: "Legal - ".concat("SpaClub"),
        images: [{
          url: "https://".concat("www.spaclub.co").concat("/images/og-spaclub.png"),
          width: 1200,
          height: 630,
          alt: "".concat("SpaClub").concat(" - The Spa You Need"),
          type: "image/png"
        }],
        siteName: "".concat("SpaClub").concat(" - The Spa You Need")
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_web_Header__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      setSideMenuShow: setSideMenuShow
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_web_SideMenu__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      sideMenuShow: sideMenuShow,
      setSideMenuShow: setSideMenuShow,
      sideMenuHeaderShow: sideMenuHeaderShow,
      setSideMenuHeaderShow: setSideMenuHeaderShow
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
      className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("background5", true)),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: "wrapper mx-auto relative py-40 min-h-screen",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
          className: "mx-auto max-w-440px",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "flex flex-col items-center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h1", {
              className: "text-3xl font-bold ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " text-center mb-16"),
              children: t("key_web_legal")
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("a", {
              href: "/privacy-policy",
              className: "text-lg ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " hover:underline font-semibold text-center w-full mb-6"),
              children: "Privacy Policy"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("a", {
              href: "/t-cs",
              className: "text-lg ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " hover:underline font-semibold text-center w-full mb-6"),
              children: "T & C"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("a", {
              href: "/disclaimer",
              className: "text-lg ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getClass */ .ll)("text-white", true), " hover:underline font-semibold text-center w-full mb-6"),
              children: "Disclaimer"
            })]
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_web_Footer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Legal);

/***/ }),

/***/ 1725:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal",
      function () {
        return __webpack_require__(1868);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,2427,2738,2460,9774,2888,179], function() { return __webpack_exec__(1725); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);